<template>
  <div>
    <li @click="toDetail(msg.serviceId, msg.facilitiesId)">
      <img :src="msg.banner" alt="">
      <h3 class="color_51" :class="{ 'textOver' : isTextOver }">{{ msg.title }}<span v-if="msg.price" class="red">￥{{msg.price*0.01}}</span></h3>
      <ServiceRate :score="msg.totalScore/msg.totalScoreNum" :totalScoreNum="msg.totalScoreNum" class="rate" v-if="!isTextOver"></ServiceRate>
    </li>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: Object,
      default: {},
    },
    serviceId: {
      type: String,
    },
    isTextOver: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    toDetail(serviceId, facilitiesId) {
      this.$router.push({ path: `/business/equipmentInfo/${serviceId}/${facilitiesId}`, query:this.$route.query })
    },
  },
}
</script>


<style lang="scss" scoped>
li {
  background-color: #fff;
  /*margin: .132rem;*/
  margin-bottom: 12px;
  padding: .186rem;
  border-radius: .053333rem;
  img {
    width: 100%;
    height: 5.253333rem;
    box-sizing: border-box;
    border-radius: .053333rem .053333rem 0 0;
    // border-bottom: 1px solid #c4c4c4;
  }
  h3 {
    font-size: .453333rem;
    min-height: 1.1rem;
    display: flex;
    align-items: center;
    font-weight: 600;
    margin: 0 .32rem;
  }
  .color_51{
    font-size: .36rem;
    display: flex;
    justify-content: space-between;
    .red{
      color: #f56565;
    }
  }
}
.rate{
  padding-left: .3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/components/EquipmentDemo.vue